import React, { useEffect, useRef } from "react";
import {
  IconAlarm,
  IconBoxDevice,
  IconBoxInfo,
  IconDateRange,
  IconStoreFront,
} from "../../components/Icons/Icons";
import Chart from "chart.js/auto";

export const PageMyInvestmentOpen = () => {
  const chartRef = useRef(null);

  // 🔥 Data quemada
  const mockData = {
    invertido: "COP 5.000.000",
    valor_unidad: "COP 500.000",
    vigencia: "12 meses",
    fecha_inversion: "2025-01-15",
    administrador: "Andes Capital",
    administradorLogo: "https://via.placeholder.com/80x80?text=AC",
  };

  // 🔹 Datos de la gráfica
  const investmentData = [
    { year: "2021", invertido: 2000000, retiro: -500000, rendimiento: 300000 },
    { year: "2022", invertido: 1500000, retiro: -200000, rendimiento: 400000 },
    { year: "2023", invertido: 1000000, retiro: -300000, rendimiento: 500000 },
    { year: "2024", invertido: 500000, retiro: -100000, rendimiento: 250000 },
  ];

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      new Chart(ctx, {
        type: "bar",
        data: {
          labels: investmentData.map((d) => d.year),
          datasets: [
            {
              label: "Invertido",
              data: investmentData.map((d) => d.invertido),
              backgroundColor: "rgb(85, 123, 209)",
            },
            {
              label: "Retiros",
              data: investmentData.map((d) => d.retiro),
              backgroundColor: "rgb(185, 222, 44)",
            },
            {
              label: "Distribuciones",
              data: investmentData.map((d) => d.rendimiento),
              backgroundColor: "rgb(164, 144, 238)",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true, beginAtZero: true },
          },
        },
      });
    }
  }, []);

  return (
    <div className="container mt-3">
      <div className="row g-3 align-items-stretch">
        {/* Columna izquierda */}
        <div className="col-md-6 h-100">
          <div className="p-3 h-100">
            <div className="d-flex align-items-center mb-3">
              <IconBoxInfo
                style={{ transform: "translate(0px, 2px)" }}
                colorIcon={"#1b4ec1"}
                height={"20px"}
                width={"25px"}
              />
              <h6 className="mb-0 ms-2">Información de la inversión</h6>
            </div>

            <div className="d-flex mb-3">
              <div className="box-icon me-2 d-flex align-items-center">
                <IconStoreFront />
              </div>
              <div>
                <div className="fw-bold">Posible cierre de compra</div>
                <div>{mockData.invertido}</div>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div className="box-icon me-2 d-flex align-items-center">
                <IconBoxDevice height={"20px"} width={"20px"} />
              </div>
              <div>
                <div className="fw-bold">Posible valor de unidad</div>
                <div>{mockData.valor_unidad}</div>
              </div>
            </div>

            <div className="d-flex mb-3">
              <div className="box-icon me-2 d-flex align-items-center">
                <IconAlarm />
              </div>
              <div>
                <div className="fw-bold">Tiempo de vigencia</div>
                <div>{mockData.vigencia}</div>
              </div>
            </div>

            <div className="d-flex">
              <div className="box-icon me-2 d-flex align-items-center">
                <IconDateRange />
              </div>
              <div>
                <div className="fw-bold">Fecha de solicitud</div>
                <div>{mockData.fecha_inversion}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Columna derecha */}
        <div className="col-md-6 h-100">
          <div className="p-3 h-100 d-flex flex-column">
            <div style={{ flex: 1 }}>
              <canvas ref={chartRef}></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
